import { type ImgHTMLAttributes, type ReactNode, useState } from "react";

/** Images already known to be missing, so the fallback shows at once on every later render. */
const missing = new Set<string>();

export interface BrandImageProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "onError"> {
  src: string;
  /** What to show when the image hasn't been uploaded (Admin Center → Branding). Nothing by default. */
  fallback?: ReactNode;
}

/** A brand image from the database, or its fallback when there is none. */
export function BrandImage({ src, fallback = null, alt = "", ...rest }: BrandImageProps): React.JSX.Element {
  const [failed, setFailed] = useState(() => missing.has(src));
  if (failed) return <>{fallback}</>;
  return (
    <img
      src={src}
      alt={alt}
      {...rest}
      onError={() => {
        missing.add(src);
        setFailed(true);
      }}
    />
  );
}
